import { render, staticRenderFns } from "./manage-extended-preference-dropdown-translation-modal.vue?vue&type=template&id=e6d8c900"
import script from "./manage-extended-preference-dropdown-translation-modal.vue?vue&type=script&lang=js"
export * from "./manage-extended-preference-dropdown-translation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports